/* C388 (Justin 2026-09-23, "product cards still showing with weird background colors"): the backdrop fill from C382, shared.
   Supplier blank photos are 4:5 portraits on light grey studio backdrops that differ photo to photo, so a contained photo in
   a square frame leaves bands of the frame's own grey beside it. Each photo's edges are sampled from a 64px copy (the Shopify
   CDN answers with Access-Control-Allow-Origin *) and the frame behind it is painted with those colours as gradients, so the
   backdrop runs to the frame edge; the photo's own outer pixels (many carry a thin white border) fade into that fill. An edge
   that is dark or busy (the garment touching the edge of the shot) is left alone. Results are kept in localStorage.

   window.NPEdge.fill(img, box)  paint one frame (box = the element whose background shows around the photo)
   window.NPEdge.repaint()       re-place fills after a resize
   Auto-scans the blank catalogue grid (#main-collection-product-grid) and the blanks upsell rails (.grt-upsell), and watches
   both for re-rendered cards. The blank product page (np-blank-pdp.js) calls fill() for its gallery and rail. */
(function () {
  'use strict';
  if (window.NPEdge) return;

  var cache = Object.create(null);
  var LS = 'np_edgefill_v1', LS_MAX = 600;
  function lsAll() { try { return JSON.parse(localStorage.getItem(LS) || '{}') || {}; } catch (e) { return {}; } }
  function lsSave(key, rec) {
    try {
      var all = lsAll(), keys = Object.keys(all);
      all[key] = { l: rec.left, r: rec.right, t: rec.top, b: rec.bottom, q: rec.ratio, at: Date.now() };
      if (keys.length > LS_MAX) keys.sort(function (a, b) { return (all[a].at || 0) - (all[b].at || 0); }).slice(0, keys.length - LS_MAX).forEach(function (k) { delete all[k]; });
      localStorage.setItem(LS, JSON.stringify(all));
    } catch (e) {}
  }
  function finish(rec) {
    rec.ready = true;
    rec.wait.forEach(function (f) { try { f(rec); } catch (e) {} });
    rec.wait = [];
  }
  function sample(src, done) {
    var u;
    try { u = new URL(src, location.href); } catch (e) { return; }
    /* only Shopify-hosted images answer the canvas read (CORS); anything else keeps its plain frame */
    if (!/(^|\.)shopify\.com$/.test(u.hostname) && u.origin !== location.origin) { done({ ready: true }); return; }
    u.searchParams.set('width', '64');
    var key = u.pathname;
    if (cache[key]) { if (cache[key].ready) done(cache[key]); else cache[key].wait.push(done); return; }
    var rec = cache[key] = { ready: false, wait: [done] };
    var hit = lsAll()[key];
    if (hit && hit.q) {
      rec.left = hit.l; rec.right = hit.r; rec.top = hit.t; rec.bottom = hit.b; rec.ratio = hit.q;
      finish(rec);
      return;
    }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onerror = function () { finish(rec); };
    im.onload = function () {
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!w || !h) { finish(rec); return; }
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d');
      x.drawImage(im, 0, 0);
      var d;
      try { d = x.getImageData(0, 0, w, h).data; } catch (e) { finish(rec); return; }
      function px(xx, yy) { var k = (yy * w + xx) * 4; return [d[k], d[k + 1], d[k + 2]]; }
      /* six stops along one edge; each stop averages a 2px-deep strip and is rejected if dark or busy */
      function strip(vertical, at) {
        var N = 6, len = vertical ? h : w, out = [], ok = true;
        for (var i = 0; i < N; i++) {
          var a = Math.floor(i * len / N), b = Math.max(a + 1, Math.floor((i + 1) * len / N));
          var r = 0, g = 0, bl = 0, n = 0, lo = 765, hi = 0;
          for (var t = a; t < b; t++) {
            for (var dep = 0; dep < 2; dep++) {
              var off = at === 0 ? dep + 1 : -dep - 1;
              var p = vertical ? px(at + off, t) : px(t, at + off);
              var sum = p[0] + p[1] + p[2];
              r += p[0]; g += p[1]; bl += p[2]; n++;
              if (sum < lo) lo = sum; if (sum > hi) hi = sum;
            }
          }
          var avg = [Math.round(r / n), Math.round(g / n), Math.round(bl / n)];
          if ((avg[0] + avg[1] + avg[2]) / 3 < 175 || (hi - lo) / 3 > 30) ok = false;
          out.push(avg);
        }
        return ok ? out : null;
      }
      rec.left = strip(true, 0); rec.right = strip(true, w - 1);
      rec.top = strip(false, 0); rec.bottom = strip(false, h - 1);
      rec.ratio = w / h;
      lsSave(key, rec);
      finish(rec);
    };
    im.src = u.toString();
  }
  function white(stops) {
    return !!stops && stops.every(function (c) { return c[0] >= 247 && c[1] >= 247 && c[2] >= 247; });
  }
  function grad(dir, stops) {
    return 'linear-gradient(' + dir + ', ' + stops.map(function (c) { return 'rgb(' + c.join(',') + ')'; }).join(', ') + ')';
  }
  function paint(box, rec, img) {
    var bw = box.clientWidth, bh = box.clientHeight;
    /* whatever happens next the photo may now be shown (CSS holds some photos back until this class lands) */
    box.classList.add('np-edge-done');
    if (!bw || !bh || !rec.ratio) return false;
    var bg = '', side = rec.ratio < bw / bh - 0.01, tall = rec.ratio > bw / bh + 0.01;
    /* C388c: a photo shot on WHITE needs nothing: on the grey panels it multiplies into the grey already, and on a white
       frame it is white on white. Painting it made a white box inside the grey card (the cart rail's dad hat). Only real
       grey studio backdrops get the fill. */
    if ((side && white(rec.left) && white(rec.right)) || (tall && white(rec.top) && white(rec.bottom))) { side = false; tall = false; }
    if (side && rec.left && rec.right) bg = grad('to bottom', rec.left) + ' left top / 50.5% 100% no-repeat, ' + grad('to bottom', rec.right) + ' right top / 50.5% 100% no-repeat';
    else if (tall && rec.top && rec.bottom) bg = grad('to right', rec.top) + ' left top / 100% 50.5% no-repeat, ' + grad('to right', rec.bottom) + ' left bottom / 100% 50.5% no-repeat';
    box.style.background = bg;
    box.classList.toggle('np-edgefill', !!bg);
    img = img || box.querySelector('img');
    if (img) {
      var mask = '', iw = img.clientWidth, ih = img.clientHeight;
      if (bg && iw && ih) {
        /* where the photo is drawn inside the img element: the whole element when it is sized to the photo (upsell rail),
           or the contained area when the element fills the frame (catalogue, product page) */
        var full = side ? iw : ih;
        var span = side ? Math.min(iw, ih * rec.ratio) : Math.min(ih, iw / rec.ratio);
        var a = (full - span) / 2, b = a + span;
        var inset = Math.max(2, span * 0.012), feather = Math.max(6, span * 0.03);
        mask = 'linear-gradient(' + (side ? 'to right' : 'to bottom') + ', transparent 0, transparent ' + (a + inset).toFixed(1) + 'px, #000 ' +
          (a + inset + feather).toFixed(1) + 'px, #000 ' + (b - inset - feather).toFixed(1) + 'px, transparent ' + (b - inset).toFixed(1) + 'px, transparent 100%)';
      }
      img.style.webkitMaskImage = mask;
      img.style.maskImage = mask;
    }
    return !!bg;
  }
  var boxes = [];
  function fill(img, box) {
    if (!img || !box) return;
    /* C390: the same img can be given a new photo (the quick buy popup swaps it per colour), so a frame is re-sampled
       whenever its photo's address changes */
    var cur = img.currentSrc || img.getAttribute('src') || '';
    if (box.__npEdge === img && box.__npEdgeSrc === cur && cur) return;
    box.__npEdge = img;
    box.__npEdgeSrc = cur;
    var go = function () {
      var src = img.currentSrc || img.getAttribute('src');
      if (!src) { box.classList.add('np-edge-done'); return; }
      sample(src, function (rec) { box.__npEdgeRec = rec; paint(box, rec, img); });
    };
    if (img.currentSrc || img.getAttribute('src')) go(); else img.addEventListener('load', go, { once: true });
    boxes.push(box);
  }
  function repaint() {
    boxes = boxes.filter(function (b) { return b.isConnected; });
    boxes.forEach(function (b) { if (b.__npEdgeRec && b.__npEdge) paint(b, b.__npEdgeRec, b.__npEdge); });
  }
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(repaint, 150); });

  /* auto targets: [frame selector, how to find its photo] */
  function scan(root) {
    root = root || document;
    /* blank catalogue + search results: the card's first figure is the frame */
    [].forEach.call(root.querySelectorAll('#main-collection-product-grid .product-item__image-figure'), function (fig) {
      if (!document.body.querySelector('.npbc-head') && !fig.closest('[data-np-blank-grid]')) return;
      fill(fig.querySelector('img'), fig);
    });
    /* blanks upsell rail (cart, patch product pages) */
    [].forEach.call(root.querySelectorAll('.grt-upsell .grt-product-card__main-image'), function (m) {
      fill(m.querySelector('img'), m);
    });
  }
  function watch(el) {
    if (!el || el.__npEdgeWatch || !window.MutationObserver) return;
    el.__npEdgeWatch = true;
    var q = 0;
    new MutationObserver(function () { scan(el); clearTimeout(q); q = setTimeout(function () { scan(el); }, 120); }).observe(el, { childList: true, subtree: true });
  }
  function boot() {
    scan(document);
    /* C397: watch the container; the theme replaces the grid element itself on every filter change */
    watch(document.getElementById('CollectionProductGrid') || document.getElementById('main-collection-product-grid'));
    [].forEach.call(document.querySelectorAll('.grt-upsell'), watch);
  }
  window.NPEdge = { fill: fill, repaint: repaint, scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { scan(document); [].forEach.call(document.querySelectorAll('.grt-upsell'), watch); });
})();
